import React from 'react'
import {Checkbox} from '../../checkbox'
import {RadioButton} from '../../radiobutton'

interface VotingItemSelectCompProps {
  option: string
  value: boolean
  idx: number
  multiSelectOn?: boolean
  onChange: (idx: number, val: boolean) => void
}

export const VotingItemSelectComp = (props: VotingItemSelectCompProps) => {
  const {option, idx, value, multiSelectOn} = props

  const onChange = () => {
    props.onChange(idx, !value)
  }

  if (multiSelectOn) {
    return <Checkbox text={option} value={value} onChange={onChange} />
  }

  return <RadioButton label={option} active={value} onClick={onChange} />
}
